'use client';

import type { WayOfSuccessType } from './data';

import Image from 'next/image';

import { Container, Stack, Text } from '@/components';
import { useTranslation } from '@/hooks';
import History1 from '@/images/aboutUs/history-1.png';
import History2 from '@/images/aboutUs/history-2.jpg';
import History3 from '@/images/aboutUs/history-3.jpg';
import History4 from '@/images/aboutUs/history-4.png';
import History5 from '@/images/aboutUs/history-5.jpg';
import History6 from '@/images/aboutUs/history-6.png';
import History7 from '@/images/aboutUs/history-7.png';
import History8 from '@/images/aboutUs/history-8.png';

const WayOfSuccess: WayOfSuccessType = () => {
  const { t } = useTranslation('pages.aboutUs');

  const STEPS = [
    {
      id: 1,
      title: t('wayOfSuccess.step1.title'),
      description: t('wayOfSuccess.step1.description'),
      image: History1,
    },
    {
      id: 2,
      title: t('wayOfSuccess.step2.title'),
      description: t('wayOfSuccess.step2.description'),
      image: History2,
    },
    {
      id: 3,
      title: t('wayOfSuccess.step3.title'),
      description: t('wayOfSuccess.step3.description'),
      image: History3,
    },
    {
      id: 4,
      title: t('wayOfSuccess.step4.title'),
      description: t('wayOfSuccess.step4.description'),
      image: History4,
    },
    {
      id: 5,
      title: t('wayOfSuccess.step5.title'),
      description: t('wayOfSuccess.step5.description'),
      image: History5,
    },
    {
      id: 6,
      title: t('wayOfSuccess.step6.title'),
      description: t('wayOfSuccess.step6.description'),
      image: History6,
    },
    {
      id: 7,
      title: t('wayOfSuccess.step7.title'),
      description: t('wayOfSuccess.step7.description'),
      image: History7,
    },
    {
      id: 8,
      title: t('wayOfSuccess.step8.title'),
      description: t('wayOfSuccess.step8.description'),
      image: History8,
    },
  ];

  return (
    <Container>
      <Stack align="center" justify="center" my={24} p={4}>
        <Stack
          w={{ base: '100%', md: '70%' }}
          flexDir="column"
          align="center"
          justify="center"
          gap={8}
        >
          {STEPS.map((step, i) => (
            <Stack
              key={step.id}
              flexDir={{
                base: 'column-reverse',
                md: i % 2 === 0 ? 'row' : 'row-reverse',
              }}
              mb={{ base: 8, md: 0 }}
              align="center"
              justify={i % 2 === 0 ? 'flex-start' : 'flex-end'}
              gap={8}
              w="100%"
            >
              <Stack flexDir="column" align="flex-start" justify="center">
                <Text fontSize="34px" fontWeight={700}>
                  {step.title}
                </Text>
                <Text
                  fontSize={{ base: 'xs', md: 'lg' }}
                  lineHeight={2.5}
                  textAlign={{ base: 'center', md: 'right' }}
                >
                  {step.description}
                </Text>
              </Stack>
              <Stack
                minW="250px"
                w={{ base: '100%', md: '250px' }}
                aspectRatio={1 / 1}
                border="1px solid"
                borderColor="text"
                borderRadius={18}
              >
                <Image
                  src={step.image}
                  alt="lia-way"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: 18,
                  }}
                />
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Container>
  );
};

export default WayOfSuccess;
